import React from "react";

export default function Success() {
  return (
    <div className="page1">You have successfully signed up and subscribed!</div>
  );
}
